<nav class="navbar navbar-expand-md navbar-dark bg-dark mb-4">

  <div class="container">
    <a routerLink="/" class="navbar-brand"> ClientPanel </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMain">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarMain">
      <ul class="navbar-nav mr-auto">
        <li *ngIf="isLoggedIn" class="nav-item">
          <a routerLink="/" class="nav-link"> Dashboard </a>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li *ngIf="!isLoggedIn && showRegister" class="nav-item">
          <a routerLink="/register" class="nav-link"><i class="fa fa-user-plus"></i> Register </a>
        </li>
        <li *ngIf="!isLoggedIn && showRegister" class="nav-item">
          <a routerLink="/login" class="nav-link"><i class="fa fa-sign-in"></i> Login </a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a href="#" class="nav-link"><i class="fa fa-user"></i> {{loggedInUser}}</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a routerLink="/settings" class="nav-link"><i class="fa fa-cogs"></i> Settings </a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a (click)="onLogOutClick()" href="#" class="nav-link"><i class="fa fa-sign-out"></i> Logout </a>
        </li>

      </ul>
    </div>

  </div>
</nav>